import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import * as _ from 'lodash';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { CouponsService } from 'src/app/modules/retailer/services/coupons.service';

@Component({
  selector: 'app-coupon-list',
  templateUrl: './coupon-list.component.html',
  styleUrls: ['./coupon-list.component.scss']
})
export class CouponListComponent implements OnInit {

  public loginData: any;

  public stores: any = [];
  public storesLoading: boolean = false;
  public selectedStore: any = 0;

  public coupons: any = [];
  public couponsPage: number = 1;
  public couponsCount: number = 0;
  public couponsLoading: boolean = false;
  public displayType: string; // grid/list

  public couponSource: string; // national/cpg/retailer
  public couponStatus: string; // expired/active/upcoming
  public demoStatus: any = 0; // Always 0 for retailer national coupon list

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _couponsService: CouponsService
  ) { }

  ngOnInit(): void {
    this.getStorageData();
  }

  // Go to demo national coupon list
  showDemoNationalCoupons(){
    this._router.navigate(['/retailer/demo-national-coupons'], {
      state: {
        store: this.selectedStore
      }
    });
  }

  // Go to coupon products list
  showCouponProducts(){
    this._router.navigate(['/retailer/coupon-products'], {
      state: {
        store: this.selectedStore,
        couponSource: this.couponSource
      }
    });
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('R_LOGIN');

    this.couponSource = 'retailer'; // Default retailer coupons
    this.couponStatus = 'active'; // Default active coupons
    this.displayType = 'grid'; // Default display type

    this.getStores();
  }

  // Change  display type
  changeDisplayType(type: string) {
    this.displayType = type;
  }

  // Get stores
  getStores() {
    this.stores = [];
    this.storesLoading = true;

    let getStoresBody = {
      provider_type: this.loginData.user_details.provider_type,
      provider_id: this.loginData.user_details.provider_id,
      coupon_count: true
    };

    this._couponsService.getStores(this.loginData.token, getStoresBody).subscribe(async getStoresResponse => {
      this.storesLoading = false;

      if (getStoresResponse.status === true) { // Success
        if (getStoresResponse.retailers.length == 1) {
          this.stores = getStoresResponse.retailers[0].stores;

          this.selectedStore = getStoresResponse.retailers[0].stores[0].store_id; // Set first store as default

          this.couponsPage = 1;
          this.getCoupons();
        }
      } else {
        this._utilService.showToast(getStoresResponse.message, '', 'error', {});
      }
    }, error => { // Error from getStores
      this.storesLoading = false;
    });
  }

  // Store change
  onStoreChange(event: any) {
    this.couponsPage = 1;
    this.getCoupons();
  }

  // On coupon source change
  oncouponSourceChange(source: string){
    this.couponSource = source;

    this.couponsPage = 1;
    this.getCoupons();
  }

  // On coupon status change
  oncouponStatusChange(status: string){
    this.couponStatus = status;

    this.couponsPage = 1;
    this.getCoupons();
  }

  // Get coupons
  getCoupons() {
    this.coupons = [];
    this.couponsCount = 0;
    this.couponsLoading = true;

    this._couponsService.getCoupons(this.loginData.token, this.loginData.user_details.provider_type, this.loginData.user_details.provider_id, this.loginData.user_details.provider_id, this.selectedStore, this.couponSource, this.couponStatus, this.couponsPage, this.demoStatus).subscribe(async getCouponsResponse => {
      this.couponsLoading = false;

      if (getCouponsResponse.status === true) { // Success
        this.coupons = getCouponsResponse.coupons;
        this.couponsCount = getCouponsResponse.total_count;
      } else {
        this._utilService.showToast(getCouponsResponse.message, '', 'error', {});
      }
    }, error => { // Error from getCoupons
      this.couponsLoading = false;
    });
  }

  // Coupons page change
  onCouponsPageChange(event: any) {
    this.couponsPage = event;
    this.getCoupons();
  }

  // On coupon action - Accept/Reject
  onCouponReviewAction (event: any) {
    this.getCoupons();
  }

}
